import { IconClockPause, IconSend } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { Button, Modal, useToast } from '@hana/ui';
import { INV_CUS, ISS_ROWS, issueWhy } from './inv';
import './bulkmail.i18n';
import s from './ar.module.css';

// Mint-Invoice › CONFIRM "Phát hành {ok} / {n} hoá đơn?" (không hoàn tác). Chỉ đọc: nút phát hành báo toast "Chưa mở ghi ở bản này".
export function BulkModal({ ids, total, onClose }: { ids: readonly string[] | null; total: string; onClose: () => void }) {
  const toast = useToast();
  const t = useT();
  if (!ids) return null;
  const rows = ISS_ROWS.filter((r) => ids.includes(r.dn));
  const blk = rows.filter((r) => issueWhy(r.cus));
  const ok = rows.length - blk.length;
  const go = () => { if (!ok) return; onClose(); toast({ msg: t('bm.noWrite') }); };
  return (
    <Modal
      open
      onOpenChange={(o) => !o && onClose()}
      title={t('bm.title', { ok, n: rows.length })}
      description={t('bm.desc', { total })}
      footer={<><Button icon={<IconClockPause size={16} aria-hidden="true" />} onClick={onClose}>{t('bm.later')}</Button><Button variant="primary" disabled={!ok} icon={<IconSend size={16} aria-hidden="true" />} onClick={go}>{t('bm.issue', { ok })}</Button></>}
    >
      {blk.length > 0 && (
        <div className={s.lb} role="alert">
          <b>{t('bm.blocked')}</b>
          {blk.map((r) => <div key={r.dn}><b>{r.dn} · {INV_CUS[r.cus]?.[0]}</b> — {issueWhy(r.cus)}</div>)}
        </div>
      )}
    </Modal>
  );
}
